<template>
  <v-card elevation="2" outlined shaped tile class="my-4">
    <v-card-title>
      <div @click="expand = !expand" :style="{ cursor: 'pointer' }">
        Pending Action (content is controlled by Application)
      </div>
      <div class="ml-2">
        <v-btn icon color="green" @click="moveUp(section.id)">
          <v-icon>mdi-arrow-up-bold-box</v-icon>
        </v-btn>
        <v-btn icon color="red" @click="moveDown(section.id)">
          <v-icon>mdi-arrow-down-bold-box</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-card-subtitle v-if="expand">
      <v-card-subtitle v-if="expand">
        <div>ID: {{ section.id }}</div>
        <div>Type: {{ section.type }}</div>
        <div>Sort Order: {{ section.sort_order }}</div>
      </v-card-subtitle>
    </v-card-subtitle>
  </v-card>
</template>
<script>
import { Vue } from 'vue-property-decorator';
export default Vue.extend({
  components: {},
  props: {
    section: {
      type: Object,
      required: true,
    },
    moveUp: {
      type: Function,
      required: true,
    },
    moveDown: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    expand: false,
  }),
});
</script>

<style scoped></style>
